import { render, staticRenderFns } from "./MultiDoctorSelector.vue?vue&type=template&id=43032314&"
import script from "./MultiDoctorSelector.vue?vue&type=script&lang=ts&"
export * from "./MultiDoctorSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports